import axios from 'axios';
import { Link } from 'react-router-dom';
import Loader from 'react-loader-spinner';
import React, { useEffect, useState } from 'react';

import { formatDate } from '../../utils/moment.util';

import './style.css';

const EventSection2 = () => {
  const [pastEvents, setPastEvents] = useState([]);
  const [upcomingEvents, setUpcomingEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingError, setLoadingError] = useState(false);

  const baseUrl = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    axios
      .get(`${baseUrl}/event`)
      .then(({ data: { data } }) => {
        setLoading(false);
        setPastEvents(data.pastEvents.docs || []);
        setUpcomingEvents(data.upcomingEvents.docs || []);
      })
      .catch((err) => {
        setLoading(false);
        setLoadingError(true);
      });
  }, [baseUrl]);

  return (
    <div className="wpo-event-area wpo-event-area2 section-padding">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="wpo-section-title">
              <span>Our Events</span>
              <h2>Upcoming Events</h2>
            </div>
          </div>
        </div>
        {/* TODO: REFACTOR BELOW CODE INTO A REUSABLE COMPONENT */}
        <div className="row mb-5">
          {loading ? (
            <div className="result-container">
              <Loader type="Oval" color="#d90404" height={80} width={80} />
            </div>
          ) : loadingError ? (
            <div className="result-container">
              <p>
                Could not fetch upcoming events. Refresh or check back later.
              </p>
            </div>
          ) : !upcomingEvents.length ? (
            <div className="result-container">
              <p>No upcoming events at the moment. Check back later</p>
            </div>
          ) : (
            upcomingEvents.map((event) => (
              <div
                className="col-lg-4 col-md-6 col-sm-12 col-12 custom-grid"
                key={event.slug}
              >
                <div className="wpo-event-item">
                  <div className="wpo-event-img-banner">
                    <img src={event.image} alt="" />
                    <div className="thumb-text">
                      <span>{formatDate(event.date, 'DD')}</span>
                      <span>{formatDate(event.date, 'MMM')}</span>
                      <span>{formatDate(event.date, 'YYYY')}</span>
                    </div>
                  </div>
                  <div className="wpo-event-text">
                    <h2>{event.title}</h2>
                    <ul>
                      <li>
                        <i className="fa fa-clock-o" aria-hidden="true"></i>
                        {event.time}
                      </li>
                      <li>
                        <i className="fi flaticon-pin"></i>
                        {event.location}
                      </li>
                    </ul>
                    <p>{event.excerpt.substring(0, 100)}...</p>
                    <Link to={`/events/${event.slug}`}>Learn More</Link>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
        <div className="row">
          <div className="col-12">
            <div className="wpo-section-title">
              <h2>Past Events</h2>
            </div>
          </div>
        </div>
        <div className="row mb-5">
          {loading ? (
            <div className="result-container">
              <Loader type="Oval" color="#d90404" height={80} width={80} />
            </div>
          ) : loadingError ? (
            <div className="result-container">
              <p>Could not fetch past events. Refresh or check back later.</p>
            </div>
          ) : !pastEvents.length ? (
            <div className="result-container">
              <p>No past events at the moment. Check back later</p>
            </div>
          ) : (
            pastEvents.map((event) => (
              <div
                className="col-lg-4 col-md-6 col-sm-12 col-12 custom-grid"
                key={event._id}
              >
                <div className="wpo-event-item">
                  <div className="wpo-event-img-banner">
                    <img src={event.image} alt="" />
                    <div className="thumb-text">
                      <span>{formatDate(event.date, 'DD')}</span>
                      <span>{formatDate(event.date, 'MMM')}</span>
                      <span>{formatDate(event.date, 'YYYY')}</span>
                    </div>
                  </div>
                  <div className="wpo-event-text">
                    <h2>{event.title}</h2>
                    <ul>
                      <li>
                        <i className="fa fa-clock-o" aria-hidden="true"></i>
                        {event.time}
                      </li>
                      <li>
                        <i className="fi flaticon-pin"></i>
                        {event.location}
                      </li>
                    </ul>
                    <p>{event.excerpt.substring(0, 100)}...</p>
                    <Link to={`/events/${event.slug}`}>Learn More</Link>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default EventSection2;
